import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { bindActionCreators } from 'redux'
import FontAwesome from 'react-fontawesome'
import { seatLabel } from '../../../../helpers/seat-key.helper'
import TicketSaleSelectors from '../../../../ducks/ticket-sale/ticket-sale.selectors'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import { breakpoints } from './../../../../constants/breakpoints.constants'
import TicketSaleService from './../../../../services/ticket-sale.service'
import { GREEN } from '../../../../styles/colors.style'
import { PRIMARY_COLOR, MEDIUMORANGE } from '../../../../styles/colors.style'
import { SkeletonSeatsCalculatedSelection } from '../skeletons'
import { resolvePaymentRequirement, resolvePointsRebooking } from '../../../../helpers/checkout.helper'
import { seatFareWithoutInsurance } from '../../../../helpers/cart-totals.helper'

class BusSeatSelectionModalResumeComponent extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		await TicketSaleService.getDiscountParameters().then(
			({ success, data }) => {
				if (success) {
					this.props.setFamilyDiscountParameters(data)
				}
			}
		)
	}

	render() {
		const {
			user,
			isBusSelectionReturnStep,
			conexao,
			calculatedValues,
			isCalculatingValues,
			isRebooking,
			rebookingTicketValue,
			rebookingTicketPoints
		} = this.props

		const isPublicBody = user && user.hasPublicBody

		// O seguro não aparece na seleção de poltronas: sai do total aqui e só entra no resumo
		// do pagamento (order-summary.component.jsx), onde o cliente pode desligá-lo.
		const insuranceValue = calculatedValues.totalInsuranceValue || 0
		const insurancePoints = calculatedValues.totalInsurancePoints || 0
		// Em "só pontos" o seguro é pago em pontos (legado `ComputeTicketCostCommandHandler`): o
		// `totalInsuranceValue` (`totals.Grand.Insurance`, em reais) não está no valor em reais a
		// pagar nem no `amountDue` da remarcação - só sai dos pontos. Mesma regra de
		// `seatFareWithoutInsurance`.
		const insuranceInMoney = insurancePoints > 0 ? 0 : insuranceValue
		const totalOrderValue = Math.max(
			0,
			(calculatedValues.totalOrderValue || 0) - insuranceInMoney
		)
		const totalPointsUsed = Math.max(
			0,
			(calculatedValues.totalPointsUsed || 0) - insurancePoints
		)
		// Bug 8093: pela mesma regra, cada poltrona também aparece sem o seguro. Só na exibição:
		// o `fare` com seguro segue valendo no resumo do pagamento e nos bilhetes.
		const withoutInsurance = (ticket) => ({
			...ticket,
			fare: seatFareWithoutInsurance(ticket)
		})
		const ticketsGoing = calculatedValues.ticketsGoing.map(withoutInsurance)
		const ticketsReturn = calculatedValues.ticketsReturn.map(withoutInsurance)

		// Mesmo cálculo do resumo do pagamento (order-summary.component.jsx): cobrar/estornar/nada-a-pagar
		// prefere o rebookingContext do carrinho (já atualizado a cada poltrona) e só cai pro Redux
		// congelado (clique em "Remarcar") quando o carrinho ainda não tem o contexto de remarcação.
		let { hasValueToRefund, totalValue } = resolvePaymentRequirement({
			rebookingContext: calculatedValues.rebookingContext,
			isRebooking,
			rebookingTicketValue,
			totalOrderValue
		})

		// O amountDue do rebookingContext já vem líquido e, quando o seguro é pago em reais, com ele
		// dentro: tira o seguro do valor com sinal (cobrança positiva, estorno negativo) e
		// reclassifica. Na remarcação só com pontos o amountDue não tem o seguro e fica como está.
		if (calculatedValues.rebookingContext && insuranceInMoney > 0) {
			const signedValue =
				(hasValueToRefund ? -totalValue : totalValue) - insuranceInMoney
			hasValueToRefund = signedValue < 0
			totalValue = Math.abs(signedValue)
		}

		const originalTicketValue = calculatedValues.rebookingContext
			? calculatedValues.rebookingContext.originalTicketValue
			: rebookingTicketValue
		// Bug 8002: crédito e diferença em pontos pelo mesmo helper do resumo do pagamento.
		const { originalTicketPoints, pointsDifference, hasPointsToRefund } = resolvePointsRebooking({
			rebookingContext: calculatedValues.rebookingContext,
			isRebooking,
			rebookingTicketPoints,
			totalPointsUsed
		})

		const noTotal = totalOrderValue == 0 && totalPointsUsed == 0

		const hasPlusSign =
			totalOrderValue > 0 && totalPointsUsed > 0 ? ' + ' : ''

		const msgServiceCharge =
			'Através desta taxa podemos prover tecnologia para você garantiar sua passagem de ônibus online e com antecedência: )'

		const showCohabitingMessage = false

		let isOnewayConnection = false
		let isReturnConnection = false

		if (conexao) {
			isOnewayConnection =
				conexao.conexaoIda && conexao.conexaoIda.trecho.length
			isReturnConnection =
				conexao.conexaoVolta && conexao.conexaoVolta.trecho.length
		}

		const groupedOnewayTrips = Object.entries(
			ticketsGoing.reduce((prev, curr) => {
				prev[curr.tripDate]
					? prev[curr.tripDate].push(curr)
					: (prev[curr.tripDate] = [curr])
				return prev
			}, {})
		)

		const groupedReturnTrips = Object.entries(
			ticketsReturn.reduce((prev, curr) => {
				prev[curr.tripDate]
					? prev[curr.tripDate].push(curr)
					: (prev[curr.tripDate] = [curr])
				return prev
			}, {})
		)

		return (
			<React.Fragment>
				{showCohabitingMessage && (
					<StyledWarningMessage>
						<span>
							<b>Sozinho, não compre assentos no corredor!</b> Eles são
							exclusivos para coabitantes dos assentos da janela ao lado.
						</span>
					</StyledWarningMessage>
				)}
				<span className={'title-color f-x-large'}>Suas poltronas</span>
				<br />
				<hr />

				{isCalculatingValues ? (
					<SkeletonSeatsCalculatedSelection />
				) : (
					<React.Fragment>
						<span className={'blue f-large'}>
							Viagem de ida
							<br />
						</span>

						{!ticketsGoing.length ? (
							<StyledValue>Nenhuma poltrona selecionada.</StyledValue>
						) : null}

						{isOnewayConnection
							? groupedOnewayTrips.map(([key, value]) => {
								return (
									<div id={key}>
										<span className={'blue f-small'}>
											{value[0].originCity} {' > '}
											{value[0].destinationCity}
											<br />
										</span>
										{value.map(
											(
												{ fare, busSeat, bpePointsUsed, floorLabel },
												index
											) => (
												<StyledPrice
													key={index}
													number={busSeat}
													floorLabel={floorLabel}
													price={fare}
													bpePointsUsed={bpePointsUsed}
												/>
											)
										)}
									</div>
								)
							})
							: ticketsGoing.map(
								({ fare, busSeat, bpePointsUsed, floorLabel }, index) => (
									<StyledPrice
										key={index}
										number={busSeat}
										floorLabel={floorLabel}
										price={fare}
										bpePointsUsed={bpePointsUsed}
									/>
								)
							)}

						{isBusSelectionReturnStep ? (
							<React.Fragment>
								<br />
								<span className={'blue f-large'}>
									Viagem de volta
									<br />
								</span>
								{!ticketsReturn.length ? (
									<StyledValue>
										Nenhuma poltrona selecionada.
									</StyledValue>
								) : null}

								{isReturnConnection
									? groupedReturnTrips.map(([key, value]) => {
										return (
											<div id={key}>
												<span className={'blue f-small'}>
													{value[0].originCity} {' > '}
													{value[0].destinationCity}
													<br />
												</span>
												{value.map(
													(
														{ fare, busSeat, bpePointsUsed, floorLabel },
														index
													) => (
														<StyledPrice
															key={index}
															number={busSeat}
															floorLabel={floorLabel}
															price={fare}
															bpePointsUsed={bpePointsUsed}
														/>
													)
												)}
											</div>
										)
									})
									: ticketsReturn.map(
										({ fare, busSeat, bpePointsUsed, floorLabel }, index) => (
											<StyledPrice
												key={index}
												number={busSeat}
												floorLabel={floorLabel}
												price={fare}
												bpePointsUsed={bpePointsUsed}
											/>
										)
									)}
							</React.Fragment>
						) : null}
						<hr />
						<StyledValueMin>
							<div>Subtotal</div>
							<div>
								{noTotal ? <span>{(0).$toReais()}</span> : null}
								{!!calculatedValues.totalPointsBpe ? (
									<span>
										{calculatedValues.totalPointsBpe.toLocaleString(
											'pt-BR'
										)}{' '}
										pts
									</span>
								) : null}
								{hasPlusSign}
								{!!totalOrderValue ? (
									<span>{calculatedValues.subtotalValue.$toReais()}</span>
								) : null}
							</div>
						</StyledValueMin>

						{!isPublicBody &&
							!calculatedValues.feesIncludedInSubtotal &&
							!!calculatedValues.totalFeeSummary && (
							<StyledValueMin>
								<div>Taxas, Impostos e Pedágios</div>
								<div>
									<span>
										{calculatedValues.totalFeeSummary.$toReais()}
									</span>
								</div>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalConvenienceFee && (
							<StyledValueMin>
								<div>
									Taxa de Serviço{' '}
									<FontAwesome
										name="info-circle"
										data-for="servicecharge-tooltip"
										data-tip="true"
										data-multiline="true"
										data-html="true"
									/>
								</div>
								<div>
									<span>
										{calculatedValues.totalConvenienceFee.$toReais()}
									</span>
								</div>
								<ReactTooltip
									id="servicecharge-tooltip"
									aria-haspopup="true"
									effect="solid"
									place="bottom">
									{msgServiceCharge}
								</ReactTooltip>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalPointsForConvenienceFee && (
							<StyledValueMin>
								<div>
									Taxa de Serviço{' '}
									<FontAwesome
										name="info-circle"
										data-for="servicecharge-tooltip"
										data-tip="true"
										data-multiline="true"
										data-html="true"></FontAwesome>
								</div>
								<div>
									<span>
										{calculatedValues.totalPointsForConvenienceFee}{' '}
										pts
									</span>
								</div>
								<ReactTooltip
									id="servicecharge-tooltip"
									aria-haspopup="true"
									effect="solid"
									place="bottom">
									{msgServiceCharge}
								</ReactTooltip>
							</StyledValueMin>
						)}

						{!!calculatedValues.totalDiscount && (
							<StyledValueMin>
								<div style={{ color: GREEN }}>Descontos</div>
								<div style={{ color: GREEN }}>
									{
										<span>
											-{calculatedValues.totalDiscount.$toReais()}
										</span>
									}
								</div>
							</StyledValueMin>
						)}

						{isRebooking && (
							<StyledValueMin>
								<div style={{ color: GREEN }}>Bilhete original</div>
								<div style={{ color: GREEN }}>
									{originalTicketPoints > 0
										? `${originalTicketPoints.toLocaleString('pt-BR')} pts + `
										: ' -'}
									{`${originalTicketValue.$toReais()}`}
								</div>
							</StyledValueMin>
						)}

						<hr />

						<StyledValueMin>
							<div style={{ fontWeight: 'bold' }}>
								Total
								{isRebooking
									? hasValueToRefund
										? ' a estornar'
										: ' a pagar'
									: ''}
							</div>
							<div style={{ fontWeight: 'bold' }}>
								{isRebooking ? (
									// Remarcação: totalValue já é o valor líquido (cobrar/estornar/nada
									// - resolvePaymentRequirement, mesmo cálculo do payment-step/order-summary).
									<span>{totalValue.$toReais()}</span>
								) : (
									<React.Fragment>
										{noTotal ? <span>{(0).$toReais()}</span> : null}
										{!!totalPointsUsed ? (
											<span>
												{totalPointsUsed.toLocaleString('pt-BR')} pts
											</span>
										) : null}
										{hasPlusSign}
										{!!totalOrderValue ? (
											<span>{totalOrderValue.$toReais()}</span>
										) : null}
									</React.Fragment>
								)}
							</div>
						</StyledValueMin>

						{isRebooking && pointsDifference !== 0 && (
							<StyledValueMin data-testid="rebooking-points-total">
								<div style={{ fontWeight: 'bold' }}>
									Total Pontos {hasPointsToRefund ? 'a estornar' : 'a pagar'}
								</div>
								<div style={{ fontWeight: 'bold' }}>
									{`${Math.abs(pointsDifference).toLocaleString('pt-BR')} pts`}
								</div>
							</StyledValueMin>
						)}
					</React.Fragment>
				)}
			</React.Fragment>
		)
	}
}

const StyledPrice = ({ number, price, bpePointsUsed, floorLabel }) => {
	return (
		<StyledValue>
			{/* Spec 055 (D7): "01 · Térreo" quando o ônibus tem mais de um andar. */}
			<div id={`seat-reserved-${number}`}>
				Poltrona {seatLabel(number, floorLabel)}
			</div>
			<div>
				{bpePointsUsed > 0 ? (
					<span>{bpePointsUsed.toLocaleString('pt-BR')} pts</span>
				) : null}
				{price > 0 && bpePointsUsed > 0 ? ' + ' : ''}
				{price > 0 ? <span>{price.$toReais()}</span> : null}
			</div>
		</StyledValue>
	)
}

const StyledValue = styled.div`
	display: flex;
	font-size: x-large;
	justify-content: space-between;
	margin: 5px 0px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: initial;
		margin-left: 30px;
		margin-top: 10px;
	}
`

const StyledValueMin = styled.div`
	display: flex;
	font-size: x-large;
	justify-content: space-between;
	margin: 1px 0px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: initial;
		margin-left: 30px;
		margin-top: 0px;
		margin-bottom: 0px;
	}
`
const StyledWarningMessage = styled.div`
	background: linear-gradient(${PRIMARY_COLOR}, ${MEDIUMORANGE});
	border-radius: 5px;
	box-shadow: 0px 0px 7px 1px black;
	color: white;
	padding: 10px;
	margin-bottom: 20px;
	line-height: 22px;
`

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setFamilyDiscountParameters:
				TicketSaleCreators.setFamilyDiscountParameters
		},
		dispatch
	)
const mapStateToProps = store => ({
	user: store.user,

	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	isBusSelectionReturnStep: TicketSaleSelectors.isBusSelectionReturnStep(
		store
	),
	conexao: store.conexao,
	familyDiscountParameters: TicketSaleSelectors.getFamilyDiscountParameters(
		store
	),
	familyDiscountAllowed: store.ticketSale.familyDiscountAllowed,
	isCalculatingValues: store.ticketSale.isCalculatingValues,
	// Mesmo cálculo do resumo do pagamento (order-summary.component.jsx) - "Bilhete original"
	// e o total líquido (cobrar/estornar/nada-a-pagar) da remarcação.
	isRebooking: store.ticketSale.rebookingData.isRebooking,
	rebookingTicketValue: store.ticketSale.rebookingData.rebookingValue,
	rebookingTicketPoints: store.ticketSale.rebookingData.rebookingPoints
})

export const BusSeatSelectionModalResume = connect(
	mapStateToProps,
	mapDispatchToProps
)(BusSeatSelectionModalResumeComponent)

export default BusSeatSelectionModalResume
